import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { Button } from "react-bootstrap";
import FileUpload from "components/sales/fileUpload/fileUpload";
import s from "components/sales/paymentPortal/addAdvance/addAdvance.module.css";
import ModalPop from "components/sales/modal/modal";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './Modify.css'
import { documentUploadUrl } from "services/redux/fileUpload/action";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";

const ModifyClaim = ({
    showModifyPopup,
    businessList,
    onClosePopup = () => {
    },
    documentUploadUrl,
    paymentReference,
    modificationRequest,
    backToModificationRequest = [],
    unclaimedId,
    id,
    resetCount = 0,
    isDisable = false
}) => {

    const [inputList, setInputList] = useState({
        business_id: "1",
        remarks: "",
        attachments: "",
        is_image_remove: false
    });

    const [invoice, setInvoice] = useState([
        {document_type: "", invoice_number: "", amount: "", tds: "" },
    ]);

    useEffect(() => {
        setInvoice([{
            document_type: businessList?.invoice_data?.document_type,
            invoice_number: businessList?.invoice_data?.invoice_number,
            amount: businessList?.invoice_data?.amount,
            tds: businessList?.invoice_data?.tds,
        }]);

        setInputList({
            remarks: businessList?.remarks,
        })
    }, [businessList]);

    const handleValidateObj = (obj) => {
        for (const key in obj) {
            if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
                return false;
            }
        }
        return true;
    };

    const [isLoading, setIsLoading] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(isDisable);
    const [attach, setAttch] = useState();
    const [showImages, setShowImages] = useState(true)
    const [count, setCount] = useState(resetCount)

    const handleInputChange = (val, index, type) => {
        const list = [...invoice];
        list[index][type] = val;
        setInvoice(list);
    };

    async function submit() {
        setIsLoading(true);
        let isError = false;
        let msg = "";
        invoice.map((val, i) => {
            if (val?.document_type === "") {
                msg = "Invoice no is missing";
                isError = true;
            }
            if (val?.invoice_number === "") {
                msg = "Invoice no is missing";
                isError = true;
            }
            if (val?.amount === "") {
                msg = "Invoice amount is missing";
                isError = true;
            }
            if (val?.tds === "") {
                msg = "Invoice tds is missing";
                isError = true;
            }
        });

        if (isError) {
            toast.error(msg);
            setDisableSubmit(false);
            return false;
        }
        const isNotEmpty = handleValidateObj(inputList);
        if (isNotEmpty !== false) {
            const isInvoice = handleValidateObj(invoice);
            if (isInvoice !== false) {
                setDisableSubmit(true);
                setIsLoading(true);
                const payload = {
                    ...inputList,
                    payment_ref_no: paymentReference,
                    invoice_data: invoice,
                    id: unclaimedId.toString(),
                    request_id: businessList?.request_id, // Include request_id in the payload,
                    is_image_remove: !showImages
                };

                const { data } = await modificationRequest(payload);
                onClosePopup();
                setShowImages(true)
                setIsLoading(false);
            } else {
                setDisableSubmit(false);
                setIsLoading(false);
                toast.error("Please fill invoice number!");
            }
        } else {
            setDisableSubmit(false);
            setIsLoading(false);
            toast.error("Please fill all details!");
        }
    }

    useEffect(() => {
        setDisableSubmit(false);
        if (backToModificationRequest?.status !== undefined && parseInt(backToModificationRequest?.status) === 400) {
            setDisableSubmit(false)
            if (backToModificationRequest?.message) {
                setIsLoading(false);
                toast.error(backToModificationRequest.message);
                setTimeout(() => {
                    window.location.reload()
                }, 7000)
            } else {
                setIsLoading(false);
                toast.error("Some error occurred!");
                setDisableSubmit(false);
            }
        } else if (backToModificationRequest?.status !== undefined && parseInt(backToModificationRequest?.status) === 200) {
            setIsLoading(false);
            toast.success("Claim raised successfully");
            setDisableSubmit(false);
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        }
        backToModificationRequest['status'] = undefined

    }, [backToModificationRequest])

    return (
        <>
            <ModalPop
                title={"Modify Claim"}
                show={showModifyPopup}
                handleModalHide={() => {
                    onClosePopup();
                }}
            >
                <div className={""}>
                    <div>
                        <div className="row">
                            <div className="col-md-4">
                                <DropDownInput
                                    data={[
                                    { id: "INVOICE", name: "INVOICE" },
                                    { id: "DEBITNOTE", name: "DEBITNOTE" },
                                    ]}
                                    label={"Document Type"}
                                    required
                                    value={invoice[0].document_type || ""}
                                    getIdValue={(val) => handleInputChange(val.id, 0, "document_type")}
                                    isStarRequired={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label={'Document Number'}
                                    type="text"
                                    required
                                    value={invoice[0].invoice_number || ""}
                                    handleChange={(val) =>
                                        handleInputChange(val, 0, "invoice_number")
                                    }
                                    isStarRequired={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label={localization.amount}
                                    type="number"
                                    required
                                    value={invoice[0].amount || ""}
                                    handleChange={(val) => handleInputChange(val, 0, "amount")}
                                    isStarRequired={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <ConstantInput
                                    label={localization.tdsAmount}
                                    type="number"
                                    required
                                    value={invoice[0].tds || ""}
                                    handleChange={(val) => handleInputChange(val, 0, "tds")}
                                    isStarRequired={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <ConstantInput
                                    label={localization.remark}
                                    type="text"
                                    required
                                    value={inputList?.remarks}
                                    handleChange={(val) => {
                                        setInputList({
                                            ...inputList,
                                            remarks: val,
                                        });
                                    }}
                                    isStarRequired={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <FileUpload
                                    id={id}
                                    multiple={true}
                                    accept=".pdf,.png,.jpg"
                                    documentUploadUrl={documentUploadUrl}
                                    onChange={(val) => {
                                        setInputList({
                                            ...inputList,
                                            attachments: val.toString(),
                                        });
                                        setAttch(val?.toString())
                                    }}
                                >
                                    <span className="btn btn-transparent">
                                        {localization.uploadPaymentProof}
                                    </span>
                                </FileUpload>
                            </div>
                        </div>
                        <div className="row">
                            {showImages && businessList?.payment_proof_doc !== undefined && businessList?.payment_proof_doc !== "" && Object.keys(businessList?.payment_proof_doc).length > 0 &&
                                businessList?.payment_proof_doc.map((val, i) => {
                                    return (
                                    <div className="col-md-4">
                                        <DocumentView key={i + 1} title={`${localization.image} ${i + 1}`} attachment={val} />
                                    </div>
                                        // <div className="col-2">
                                        //     <img src={val} alt={""} style={{width: "50%"}}/>
                                        // </div>
                                    )
                                })
                            }

                            {showImages && businessList?.payment_proof_doc !== undefined && businessList?.payment_proof_doc !== "" && Object.keys(businessList?.payment_proof_doc).length > 0 &&
                                <div className="modify-unclaimed-img-remove" onClick={() => { setShowImages(false) }}>X</div>
                            }
                        </div>
                        <div className="col-md-12 col-sm-12">
                            <div className={s.button}>
                                <Button onClick={() => submit()} disabled={disableSubmit}>
                                    {`Raise Claim`}
                                </Button>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </ModalPop>
        </>
    );
};

// ModifyClaim.propTypes = {
//     showModifyPopup: PropTypes.bool,
//     businessList: PropTypes.object,
//     onClosePopup: PropTypes.func,
//     documentUploadUrl: PropTypes.func,
//     paymentReference: PropTypes.string,
//     match: PropTypes.object,
//     history: PropTypes.object,
//     unclaimedId: PropTypes.string,
//     request_id: PropTypes.string, // Include request_id in propTypes
// };

const mapDispatchToProps = (dispatch) => bindActionCreators({
    documentUploadUrl,
}, dispatch);

export default connect(null, mapDispatchToProps)(ModifyClaim);
